class CircularSlider {
  constructor(wrapper, items) {
    this.element = wrapper;
    this.items = items;

    this.style = window.getComputedStyle(this.element);

    this.reference = this.element.querySelector(".circular-reference");
    if (this.reference) {
      this.reference.style.borderRadius = "50%";
      this.reference.style.position = "absolute";
    }

    this.progress = 0;

    this.params = {
      gap: 0,
      debounce: 0,
    };

    this.update();
  }

  get is_overflow() {
    return this.getMaxItemWidth() * this.items.length > this.bounds.width;
  }

  getMaxItemWidth() {
    const items = Array.from(this.items);
    const items_width = items.map((item) => item.offsetWidth);

    return Math.max(...items_width);
  }
  getMaxItemHeight() {
    const items = Array.from(this.items);
    const items_height = items.map((item) => item.offsetHeight);

    return Math.max(...items_height);
  }

  getBottomCornerOffset(angle, side) {
    return side * (this.getMaxItemWidth() / 2) * Math.cos(angle);
  }

  getMinRotation() {
    const angle_estimated = Math.asin(
      (this.getMaxItemWidth() / 2 - this.center.x) / this.radius
    );

    const offset = this.getBottomCornerOffset(angle_estimated, -1);
    const angle_corrected = Math.asin((-offset - this.center.x) / this.radius);

    return angle_corrected - this.angle.start;
  }
  getMaxRotation() {
    const angle_base =
      this.angle.start + this.angle.step * (this.items.length - 1);
    const angle_estimated = Math.asin(
      (this.bounds.width - this.getMaxItemWidth() / 2 - this.center.x) /
        this.radius
    );
    const offset = this.getBottomCornerOffset(angle_estimated, +1);
    const angle_corrected = Math.asin(
      (this.bounds.width - offset - this.center.x) / this.radius
    );

    return angle_corrected - angle_base;
  }

  getProgress() {
    if (!this.is_overflow) return 0;

    return (
      this.rotation.min +
      this.progress * (this.rotation.max - this.rotation.min)
    );
  }

  getCircleRadius() {
    const wrapper_half_width = this.bounds.width / 2;

    const offset = this.getMaxItemHeight() - this.bounds.height;

    return -(wrapper_half_width ** 2 + offset ** 2) / (2 * offset);
  }
  getCircleCenter() {
    return {
      x: this.bounds.width / 2,
      y: this.radius + this.getMaxItemHeight(),
    };
  }

  getAngleStep(radius) {
    return (
      2 * Math.asin((this.getMaxItemWidth() + this.params.gap) / (2 * radius))
    );
  }
  getAngleStart(angle_step) {
    const total_angle = angle_step * (this.items.length - 1);

    return -total_angle / 2;
  }

  setItemTransform(item, angle) {
    const angle_adjust = angle - Math.PI / 2;

    const x = this.center.x + this.radius * Math.cos(angle_adjust);
    const y = this.center.y + this.radius * Math.sin(angle_adjust);

    const tx = x - item.offsetWidth / 2;
    const ty = y - item.offsetHeight;

    item.style.transformOrigin = "center bottom";
    item.style.transform = `translate3d(${tx}px, ${ty}px, 0) rotate(${angle}rad)`;
  }

  update() {
    let params;

    params = {};
    params.gap = this.style.getPropertyValue("--gap") || 0;

    this.params.gap = parseInt(params.gap);

    this.bounds = this.element.getBoundingClientRect();

    this.radius = this.getCircleRadius();
    this.center = this.getCircleCenter();

    this.angle = {};
    this.angle.step = this.getAngleStep(this.radius);
    this.angle.start = this.getAngleStart(this.angle.step);

    this.rotation = {};
    this.rotation.min = this.getMinRotation();
    this.rotation.max = this.getMaxRotation();
    this.rotation.current = this.getProgress();

    this.items.forEach((item, i) => {
      const angle = this.angle.start + this.angle.step * i + this.rotation.current;

      this.setItemTransform(item, angle);
    });

    if (!this.reference) return;

    this.reference.style.height = `${this.radius * 2}px`;
    this.reference.style.width = `${this.radius * 2}px`;
    this.reference.style.left = `${this.center.x - this.radius}px`;
    this.reference.style.top = `${this.center.y - this.radius}px`;
  }
}

class SliderPackets extends HTMLElement
{
    connectedCallback()
    {
        const wrapper = this.querySelector('.banner-store-locator-slider-wrapper')
        const items = wrapper.querySelectorAll('.banner-store-locator-slider-item')

        this.immediate = true;

        this.slider = new CircularSlider(wrapper, items);

        this._scrollHandler = () => this._scroll();
        this._resizeHandler = () => this._resize();
        this._intersectHandler = (...args) => this._intersect(...args);

        this.observer = new IntersectionObserver(this._intersectHandler)
        this.observer.observe(this);

        window.addEventListener('scroll', this._scrollHandler)
        window.addEventListener('resize', this._resizeHandler);
    }

    disconnectedCallback()
    {
        window.removeEventListener('scroll', this._scrollHandler)
        window.removeEventListener('resize', this._resizeHandler)

        this.observer.disconnect()
    }

    _resize()
    {
        this._scroll()
        this.slider.update()
    }

    _scroll()
    {
      if( ! this.visible ) return

      let progress;

      const { innerHeight: vh } = window;
      const { bottom, height } = this.getBoundingClientRect();

      progress = bottom / (vh + height);
      progress = clamp(0, 1, progress);

      this.slider.progress = clamp(0, 1, progress)
      this.slider.update();
    }

    _intersect(entries)
    {
        entries.forEach(entry => {
            this.visible = entry.isIntersecting

            if( this.immediate ) {
              this._scrollHandler()

              console.log('ok')

              this.immediate = false
            }
        })
    }
}

customElements.define('slider-store-locator', SliderPackets)

function debounce(fn, wait) {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), wait);
  };
}

function clamp(min, max, val) {
    return Math.min(Math.max(val, min), max);
}